<template>
  <div>
    <TableHistorico @recibo="openRecibo" @historico="openHistorico" @anexo="openAnexo" />
    <ModalHistorico :title="title" v-model="show" ref="historico" />
    <ModalAnexo v-model="showAnexo" ref="anexo" />
    <overlay-loading v-model="loadingOverlay" />
  </div>
</template>

<script>
import TableHistorico from './Shared/TableHistorico';
import ModalHistorico from './Shared/ModalHistorico';
import ModalAnexo from './Shared/ModalAnexo';
import { EventBus } from '@/services/EventBus/EventBus';

export default {
  components: {
    TableHistorico,
    ModalHistorico,
    ModalAnexo
  },
  data() {
    return {
      show: false,
      showAnexo: false,
      title: '',
      loadingOverlay: false
    }
  },
  methods: {
    openHistorico(id) {
      this.title = 'Histórico'
      this.show = true
      this.$refs.historico.start(id, false)
    },
    async openRecibo(id) {
      this.title = 'Comprovante de atualizações – Aplicativo CADU';
      this.loadingOverlay = true
      await this.$refs.historico.imprimirRecibo(id, true);
      this.loadingOverlay = false;
      EventBus.$emit('atualizarAlertas');
    },
    openAnexo(id) {
      this.showAnexo = true
      this.$refs.anexo.start(id);
    }
  }
}
</script>
